import React, { useState, useEffect } from "react";

const ADDONS = [
  { id: "tube", name: "Tube", description: "Towable 2-person tube", price: 50 },
  { id: "pets", name: "Pets", description: "Pet cleaning fee", price: 30 },
  { id: "moreTime", name: "2 More Hours", description: "Extend your rental by 2 hours (available only for 10–6 rentals)", price: 80 },
];

const AddonForm = ({ initialAddons = [], onSubmit }) => {
  const [selectedAddons, setSelectedAddons] = useState([]);

  useEffect(() => {
    setSelectedAddons(initialAddons);
  }, [initialAddons]);

  const toggleAddon = (id) => {
    setSelectedAddons((prev) =>
      prev.includes(id) ? prev.filter((a) => a !== id) : [...prev, id]
    );
  };

  const submit = (e) => {
    e.preventDefault();
    onSubmit(selectedAddons);
  };

  const reset = (e) => {
    e.preventDefault();
    setSelectedAddons(initialAddons || []);
  };

  return (
    <form className="p-3 border rounded">
      {ADDONS.map((addon) => (
        <div key={addon.id} className="form-check mb-2">
          <input
            className="form-check-input"
            type="checkbox"
            id={addon.id}
            checked={selectedAddons.includes(addon.id)}
            onChange={() => toggleAddon(addon.id)}
          />
          <label className="form-check-label" htmlFor={addon.id}>
            <strong>{addon.name}</strong> – {addon.description} (${addon.price})
          </label>
        </div>
      ))}

      <div className="modal-btn-container mt-3">
        <button className="form-secondary-btn btn" onClick={reset}>Reset</button>
        <button className="form-primary-btn btn" onClick={submit}>Submit</button>
      </div>
    </form>
  );
};

export default AddonForm;
